import SelectObject from "../../assets/SelectObject";
import {EMPTY_INN, MODAL_LIST_OBJECTS} from "../../assets/constants";
import {RichCell} from "@vkontakte/vkui";
import React from "react";
import KlientsItem from "./item";
import * as constants from "../../assets/constants";

class KlientsSelectObject extends SelectObject {

    renderCreateForm() {
        const base_url = constants.DEBUG ? constants.base_url_stage : constants.base_url_prod
        return <KlientsItem
            base_url={base_url}
            current_user={this.props.current_user}
            item={this.state.current_object}
            change={this.editCurrentKlient}
            hideForm={() => this.closeList()}
            onCreate={(value) => {
                this.setState({current_object: value})
                window.postMessage({type: 'newKlientCreated', value})
                window.postMessage('closeSelectObject' + this.guid
            )}}
        />
    }

    createAction() {
        super.createAction()
        this.setState({current_object: {id: -1}})
        window.postMessage({
            type: 'setCurrentKlient',
            value: {id: -1}
        })
    }

    editCurrentKlient = (e, fieldName) => {
        const {current_object} = this.state
        //console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_object.INN = e.data.inn
            current_object.title = e.value
            current_object.dadata_object = e
        } else {
            current_object[fieldName] = e.currentTarget.value
        }
        this.setState({current_object})
    }

    renderRow = (item, index, last_store_klients_id = null) => {


        let backgroundColor = 'inherit'


        if (item.INN == EMPTY_INN) {
            backgroundColor = 'rgba(255,75,75,0.57)'
        }

        return <RichCell key={'select-obj-' + index} onClick={() => this.selectObject(index)} multiline
                         style={{
                             border: item.external_id == last_store_klients_id ? '1px solid orange' : 'inherit',
                             backgroundColor
                         }}
                         caption={item.INN == EMPTY_INN ?
                             <span style={{color: 'red'}}>Не пройдена модерация, не известный клиент</span> : ''}
                         subhead={item.descr}
        >
            {item.name}
        </RichCell>
    }

}

export default KlientsSelectObject